module.exports = __webpack_public_path__ + "static/media/ico_repair_destination.31720389.svg";